module.exports = __webpack_public_path__ + "img/profile.a75a3286.svg";